import {
  INVITES_SEND_REQUEST,
  INVITES_SEND_SUCCESS,
  INVITES_SEND_FAILURE,
  INVITES_GET_ACCEPT_REQUEST,
  INVITES_GET_ACCEPT_SUCCESS,
  INVITES_GET_ACCEPT_FAILURE,
  INVITES_POST_ACCEPT_REQUEST,
  INVITES_POST_ACCEPT_SUCCESS,
  INVITES_POST_ACCEPT_FAILURE,
  RESET_INVITES_STATE,
} from '../../actions/actionTypes';

const INITIAL_STATE = {
  errorMessage: '',
  sendSuccessMessage: '',
  status: 'no',
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case INVITES_SEND_REQUEST:
    case INVITES_GET_ACCEPT_REQUEST:
    case INVITES_POST_ACCEPT_REQUEST:
      return {
        ...state,
        status: 'requesting',
        errorMessage: '',
        sendSuccessMessage: '',
      };
    case INVITES_SEND_SUCCESS:
      return {
        ...state,
        status: 'success',
        errorMessage: '',
        sendSuccessMessage: action.payload,
      };
    case INVITES_GET_ACCEPT_SUCCESS:
      return {
        ...state,
        status: 'success',
        errorMessage: '',
        pendingInvite: action.payload,
      };
    case INVITES_POST_ACCEPT_SUCCESS:
      return {
        ...state,
        status: 'success',
        errorMessage: '',
        pendingInvite: null,
      };
    case INVITES_GET_ACCEPT_FAILURE:
    case INVITES_POST_ACCEPT_FAILURE:
    case INVITES_SEND_FAILURE:
      return {
        ...state,
        status: 'failed',
        errorMessage: action.payload,
        sendSuccessMessage: '',
      };

    case RESET_INVITES_STATE:
      return { ...INITIAL_STATE };
    default:
      return state;
  }
}
